import type { Extension } from '@codemirror/state';
import type { SyntaxPalette } from './theme';
import { createTheme } from './theme';

const palette: SyntaxPalette = {
	keyword: '#0064ff',
	controlKeyword: '#af00db',
	variable: '#0070c1',
	type: '#267f99',
	function: '#795e26',
	number: '#098658',
	string: '#a31515',
	comment: '#008000',
	regex: '#af00db',
	modified: '#795e26',
};

export const vsCodeLight: Extension = createTheme(palette, false);

export { applyMergeRevertStyles, mergeRevertStyles } from './utils';
